import React, { Component } from 'react';
import PropTypes from 'prop-types';
import logo from '../images/drapcode-logo-white.svg';
import { getBuilderURL } from './utils/builder-url-util';
import CommonLink from './ui/CommonLink';
import VersionChangeModal from './ui/VersionChangeModal';
import PublishProjectModal from './ui/PublishProjectModal';
import PreviewProjectModal from './ui/PreviewProjectModal';
import { publishAppOnServer } from './utils/publish_utils';
import { getCookie, isProjectReadOnly } from './utils/api_utils';

const imageStyle = {
  display: 'block',
  height: '30px',
  marginLeft: 'auto',
  marginRight: 'auto',
  marginTop: 0,
  zIndex: 10,
  position: 'absolute',
  left: '50%',
  transform: 'translate(-50%,0)',
  top: '14%',
  cursor: 'pointer',
};

const versionUlStyle = {
  marginLeft: '30px',
};

const divNavbarStyle = {
  flexBasis: 'auto',
  flexGrow: 4.1,
};

const topNavLinks = [
  { title: 'App Setting', icon: 'home', seo: 'app-setting' },
  { title: 'Collections', icon: 'database', seo: 'collections' },
  { title: 'Events', icon: 'diagram-3-fill', seo: 'events' },
  { title: 'Plugins', icon: 'tools', seo: 'plugin' },
  { title: 'Templates', seo: 'template', icon: 'file-alt' },
  { title: 'Data Source', seo: 'data-connector', icon: 'hdd-stack-fill' },
  { title: 'External APIs', seo: 'externalapi', icon: 'rocket' },
];
export class TopNav extends Component {
  static propTypes = {
    projectId: PropTypes.string.isRequired,
  };

  state = {
    popoverOpen: false,
    isPublishing: false,
    selVersion: {
      ALPHA: this.props.version,
      BETA: this.props.version,
      PREVIEW: this.props.version,
      PRODUCTION: this.props.version,
    },
    versionOpen: false,
    previewPopupOpen: false,
    isPreviewPublishing: false,
  };

  handleVersionChange = (event, type) => {
    const { selVersion } = this.state;
    const {
      target: { value },
    } = event;
    selVersion[type] = value;
    this.setState({ selVersion });
  };

  publishApp = async (envType, name, cleanPublish) => {
    const { projectDetail, actions } = this.props;
    let selVersion = this.state.selVersion[envType];

    if (!selVersion) {
      selVersion = 1;
    }

    const updateState = (status) => {
      this.setState({ isPublishing: status });
      this.setState({ isPreviewPublishing: status });
    };

    try {
      const result = await publishAppOnServer(
        envType,
        name,
        updateState,
        selVersion,
        projectDetail,
        actions,
        cleanPublish,
      );

      actions.resetCollectionChange();
      return result;
    } catch (error) {
      console.error('Error during publishing:', error);
      return error;
    }
  };

  handleVersionSwitch = (event) => {
    const { target } = event;
    const { value } = target;
    const { projectId } = this.props;
    const path = location.pathname;
    const extractPath = path.split(/[/]/);
    const route = extractPath[1];
    window.location.href = `/${route}/${value}/v/${projectId}`;
  };

  showVersionChangeContent = () => {
    return (
      <VersionChangeModal
        versionOpen={this.state.versionOpen}
        toggleVersion={this.toggleVersion}
        handleVersionSwitch={this.handleVersionSwitch}
        version={this.props.version}
        versions={this.props.versions}
      />
    );
  };

  showPopoverContent = () => {
    const { projectDetail, projectId, version, versions, actions } = this.props;
    if (!projectDetail) {
      return '';
    }
    const { popoverOpen, previewPopupOpen, isPublishing, isPreviewPublishing, selVersion } =
      this.state;
    const isReadOnly = isProjectReadOnly(projectId);
    return (
      <>
        <PublishProjectModal
          popoverOpen={popoverOpen}
          toggle={this.toggle}
          projectId={projectId}
          version={version}
          projectDetail={projectDetail}
          versions={versions}
          isPublishing={isPublishing}
          selVersion={selVersion}
          publishApp={this.publishApp}
          handleVersionChange={this.handleVersionChange}
          restartApp={this.restartApp}
          actions={actions}
          isReadOnly={isReadOnly}
        />
        <PreviewProjectModal
          projectId={projectId}
          projectDetail={projectDetail}
          versions={versions}
          selVersion={selVersion}
          popoverOpen={previewPopupOpen}
          isPreviewPublishing={isPreviewPublishing}
          toggle={this.togglePreviewPopup}
          publishApp={this.publishApp}
          handleVersionChange={this.handleVersionChange}
          actions={actions}
          version={version}
          isReadOnly={isReadOnly}
        />
      </>
    );
  };

  toggle = () => {
    this.setState({ popoverOpen: !this.state.popoverOpen });
  };

  toggleVersion = () => {
    this.setState({ versionOpen: !this.state.versionOpen });
  };

  toggleGlobalSearch = () => {
    const customEvent = new CustomEvent('toggleGlobalSearch', {
      detail: { visible: true },
    });
    window.dispatchEvent(customEvent);
  };

  togglePreviewPopup = () => {
    this.setState({ previewPopupOpen: !this.state.previewPopupOpen });
  };

  openEditor = () => {
    const { projectId, version } = this.props;
    let token = getCookie('token');
    if (!token) {
      token = '';
    }
    const redirectUrl = getBuilderURL();
    window.location.href = `${redirectUrl}editor/${version}/v/${projectId}/loader?token=${token}`;
  };

  render() {
    const { projectId, projectDetail, version } = this.props;
    return (
      <nav
        className="navbar navbar-color-on-scroll navbar-expand-lg fixed-top"
        color-on-scroll="100"
        id="sectionsNav"
      >
        <div className="container-fluid">
          <div className="navbar-translate" style={divNavbarStyle}>
            <ul className="navbar-nav" style={versionUlStyle}>
              <li className="nav-item">
                <div className="nav-link" title="Version" onClick={this.toggleVersion}>
                  <i className="wb webconnect-option"></i> v({version})
                </div>
                {this.showVersionChangeContent()}
              </li>
              <li className="nav-item">
                <div className="nav-link" title="Shortcut" onClick={this.toggleGlobalSearch}>
                  <i className="wb webconnect-search"></i>
                </div>
              </li>
            </ul>
            <img
              src={logo}
              style={imageStyle}
              alt="DrapCode Logo"
              title="Goto Editor"
              onClick={this.openEditor}
            />
            <button
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="sr-only">Toggle navigation</span>
              <span className="navbar-toggler-icon"></span>
              <span className="navbar-toggler-icon"></span>
              <span className="navbar-toggler-icon"></span>
            </button>
          </div>
          <div className="collapse navbar-collapse">
            <div id="publish-popover"></div>
            {this.showPopoverContent()}
            <ul className="navbar-nav ml-auto">
              <li className="nav-item">
                <div className="nav-link" title="Preview" onClick={this.togglePreviewPopup}>
                  <i className="wb webconnect-eye-fill"></i>
                </div>
              </li>
              <li className="nav-item">
                <div className="nav-link" title="Production" onClick={this.toggle}>
                  <i className="wb webconnect-paper-plane"></i>
                </div>
              </li>
              <CommonLink
                link={`/deployment-setting/${version}/v/${projectId}/code-ui`}
                title="View Code"
                icon="layout-text-sidebar-reverse"
              />
              {topNavLinks.map((data) => (
                <CommonLink
                  key={data.seo}
                  link={`/${data.seo}/${version}/v/${projectId}/${
                    data.seo === 'app-setting' ? 'setting/app-config' : ''
                  }`}
                  title={data.title}
                  icon={data.icon}
                />
              ))}
            </ul>
          </div>
        </div>
      </nav>
    );
  }
}

export default TopNav;
